require('./navigation.js');
require('./custom.js');

//Slick-slider
//require('slick-carousel/slick/slick.js');

//FontAwesome All in one file
//require('@fortawesome/fontawesome-pro/js/all.js');

//FontAwesome parts

// Core
require('@fortawesome/fontawesome-pro');
import { library as FontAwesomeLibrary, config, dom } from '@fortawesome/fontawesome-svg-core';
config.autoA11y = true;
config.observeMutations = true;
config.autoReplaceSvg = true;

import { faTwitter, faFacebook, faInstagram, faYoutube, faLinkedin, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faPhone, faShoppingCart, faMapMarkerAlt, faSearch} from '@fortawesome/pro-solid-svg-icons';
import { faBars, faTimes } from '@fortawesome/pro-regular-svg-icons';


FontAwesomeLibrary.add(faTimes, faBars, faTwitter, faFacebook, faInstagram, faYoutube, faLinkedin, faLinkedinIn, faEnvelope, faPhone, faShoppingCart, faMapMarkerAlt, faSearch);

dom.watch();

/*
Ikonikirjastot:
free-brands-svg-icons
pro-light-svg-icons
pro-regular-svg-icons
pro-solid-svg-icons
*/


// Brands
//require('@fortawesome/fontawesome-pro/js/brands.js');

// Light
//require('@fortawesome/fontawesome-pro/js/light.js');

// Regular
//require('@fortawesome/fontawesome-pro/js/regular.js');

// Solid
//require('@fortawesome/fontawesome-pro/js/solid.js');

// v4-shims
//require('@fortawesome/fontawesome-pro/js/v4-shims.js');

jQuery('document').ready(function($){
  $('.icon button').on('click touchstart', function() {
    $(this).find('svg').toggleClass('fa-bars fa-times');
  });



  $('.categories .sub-menu').parent().addClass('parent');
  $('.categories .sub-menu').parent().prepend('<div class="cat-icon"><svg width="28" height="28" viewBox="0 0 28 28"><path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill="#D6D7D7"/></svg></div>');

  $('.cat-icon').on('click', function(){
    $(this).toggleClass('rotateicon');
    $(this).nextAll('.sub-menu').slideToggle();

    // $(this).find('svg path').attr('d');
  });

  if($('.current-menu-item .cat-icon').addClass('rotateicon')) {
    $('.sub-menu .cat-icon').removeClass('rotateicon');
  }

  if($('.sub-menu .current-menu-item').length) {
		$('.current-menu-ancestor .cat-icon').addClass('rotateicon');
	}
});
